import { render, staticRenderFns } from "./tutor.vue?vue&type=template&id=a5a44ab6&scoped=true&"
import script from "./tutor.vue?vue&type=script&lang=js&"
export * from "./tutor.vue?vue&type=script&lang=js&"
import style0 from "./tutor.vue?vue&type=style&index=0&id=a5a44ab6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5a44ab6",
  null
  
)

export default component.exports